var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApache(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M86.522.606c-2.007 1.185-5.348 4.54-9.318 9.407l3.652 6.903c2.57-3.666 5.177-6.977 7.807-9.8l.304-.325-.304.326c-.852.933-3.437 3.955-7.333 9.94 3.755-.185 9.518-.956 14.222-1.756 1.407-7.844-1.37-11.429-1.37-11.429S90.654-1.83 86.521.606z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD202E",
    d: "M74.234 58.596c-.467.081-.94.17-1.437.252 0 0-.007 0-.007.007l.74-.111c.23-.052.467-.096.704-.148z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD202E",
    d: "M74.234 58.596c-.467.081-.94.17-1.437.252 0 0-.007 0-.007.007l.74-.111c.23-.052.467-.096.704-.148z",
    opacity: 0.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD202E",
    d: "M75.456 52.559s0 .007 0 0c-.007 0-.007 0-.007.007.074-.007.155-.022.23-.037.31-.044.614-.096.91-.17-.37.067-.74.133-1.133.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD202E",
    d: "M75.456 52.559s0 .007 0 0c-.007 0-.007 0-.007.007.074-.007.155-.022.23-.037.31-.044.614-.096.91-.17-.37.067-.74.133-1.133.2z",
    opacity: 0.35
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M70.071 34.76a219.903 219.903 0 013.37-6.081 171.901 171.901 0 013.585-5.97c.067-.112.148-.23.215-.341a144.48 144.48 0 013.607-5.444l-3.651-6.904a71.1 71.1 0 00-.83 1.03 156.993 156.993 0 00-3.274 4.23 201.146 201.146 0 00-3.889 5.392 233.315 233.315 0 00-3.703 5.48 214.99 214.99 0 00-3.163 4.978c-.037.06-.074.126-.11.193l4.762 9.407a213.91 213.91 0 013.081-5.97z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M48.383 87.735a421.232 421.232 0 00-1.896 5.296c-.008.022-.015.052-.03.074-.089.252-.185.511-.266.763-.43 1.215-.8 2.311-1.652 4.793 1.4.637 2.526 2.325 3.592 4.236a7.624 7.624 0 00-2.489-5.273c6.911.31 12.867-1.437 15.948-6.489.274-.452.526-.919.755-1.43-1.4 1.778-3.14 2.526-6.407 2.348-.007 0-.014.008-.022.008.008 0 .015-.008.022-.008 4.815-2.155 7.222-4.222 9.363-7.644.504-.814 1-1.696 1.504-2.681-4.208 4.318-9.074 5.548-14.207 4.615l-3.852.422c-.126.326-.237.644-.363.97z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M50.183 79.12c.83-2.147 1.689-4.325 2.563-6.517a441.794 441.794 0 012.593-6.341 748.43 748.43 0 012.71-6.392c.934-2.17 1.897-4.333 2.882-6.489a352.9 352.9 0 012.948-6.34c.355-.756.726-1.511 1.089-2.26.63-1.296 1.266-2.585 1.91-3.859.038-.066.067-.14.104-.207l-4.762-9.407a6.52 6.52 0 01-.237.378 219.844 219.844 0 00-3.296 5.555 208.386 208.386 0 00-3.223 5.837 248.13 248.13 0 00-2.6 5.044c-.17.34-.333.689-.503 1.03a143.907 143.907 0 00-2.822 6.185 115.935 115.935 0 00-2.54 6.429c-.49 1.34-.927 2.63-1.334 3.874-.333 1.059-.645 2.126-.956 3.185a99.189 99.189 0 00-1.83 7.451l4.786 9.444c.63-1.688 1.281-3.407 1.948-5.14.2-.496.378-.985.57-1.46z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M42.828 76.595c-.6 3.022-1.03 6.03-1.245 9.022l-.022.31c-1.496-2.392-5.488-4.725-5.481-4.703 2.867 4.148 5.037 8.267 5.355 12.31-1.533.312-3.63-.14-6.051-1.029 2.526 2.326 4.422 2.963 5.17 3.14-2.326.149-4.74 1.742-7.178 3.579 3.563-1.452 6.445-2.03 8.504-1.563-3.274 9.258-6.548 19.48-9.83 30.339 1.008-.296 1.608-.978 1.941-1.889.585-1.963 4.46-14.866 10.54-31.806.178-.481.349-.97.526-1.452.045-.14.097-.274.149-.4.637-1.777 1.31-3.592 1.992-5.444.156-.422.311-.844.474-1.266 0-.008.008-.015.008-.023l-4.793-9.444a6.652 6.652 0 01-.06.319z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M67.723 41.5c-.14.282-.274.563-.415.845-.414.851-.83 1.718-1.259 2.607-.46.963-.918 1.94-1.385 2.948-.237.504-.474 1.015-.711 1.533a414.713 414.713 0 00-2.163 4.8 388.508 388.508 0 00-2.748 6.326c-.881 2.088-1.793 4.244-2.696 6.48-.867 2.12-1.74 4.312-2.63 6.563a411.904 411.904 0 00-2.392 6.208c-.037.096-.074.207-.111.303-.8 2.111-1.608 4.282-2.415 6.504-.015.051-.037.096-.052.155l3.852-.422c-.074-.015-.156-.022-.23-.037 4.6-.57 10.726-4.015 14.674-8.259 1.822-1.955 3.474-4.266 5-6.97 1.133-2.007 2.207-4.244 3.229-6.71a98.187 98.187 0 002.563-7.023c-1.06.556-2.267.97-3.6 1.252-.237.052-.474.096-.718.14-.245.045-.49.082-.741.112 0 0 .007 0 .007-.007 4.296-1.652 7-4.837 8.963-8.74-1.126.77-2.963 1.777-5.163 2.258a16.586 16.586 0 01-1.14.208h.014c1.496-.622 2.748-1.326 3.837-2.148.237-.178.467-.356.674-.548.333-.29.645-.593.956-.904.192-.207.377-.415.563-.63.43-.51.83-1.059 1.2-1.651.11-.186.23-.363.333-.556.148-.274.281-.548.415-.807a43.48 43.48 0 001.459-3.222c.192-.474.355-.904.503-1.319.06-.163.111-.318.163-.474.156-.452.274-.852.37-1.207.149-.534.238-.956.282-1.26-.148.112-.31.23-.504.341-1.296.778-3.518 1.474-5.31 1.808l3.533-.386-3.533.386c-.023.007-.052.007-.082.014-.185.03-.355.06-.54.082l.088-.045-12.095 1.326a.37.37 0 01-.045.126z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M81.337 17.057a182.438 182.438 0 00-3.518 5.651 247.572 247.572 0 00-3.674 6.4 280.913 280.913 0 00-3.289 6.155 332.218 332.218 0 00-3.074 6.111l12.096-1.326c3.526-1.622 5.096-3.081 6.622-5.207.4-.585.815-1.192 1.215-1.83a74.934 74.934 0 003.548-6.2c1.051-2.05 1.977-4.08 2.688-5.917a30.467 30.467 0 001.067-3.2c.222-.837.393-1.637.526-2.4-4.689.807-10.459 1.578-14.207 1.763z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD202E",
    d: "M73.516 58.729c-.245.044-.49.081-.741.111.252-.022.503-.067.74-.111z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD202E",
    d: "M73.516 58.729c-.245.044-.49.081-.741.111.252-.022.503-.067.74-.111z",
    opacity: 0.35
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M73.516 58.729c-.245.044-.49.081-.741.111.252-.022.503-.067.74-.111z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD202E",
    d: "M75.449 52.566c.074-.007.155-.022.23-.037-.075.008-.149.03-.23.037z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD202E",
    d: "M75.449 52.566c.074-.007.155-.022.23-.037-.075.008-.149.03-.23.037z",
    opacity: 0.35
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M75.449 52.566c.074-.007.155-.022.23-.037-.075.008-.149.03-.23.037z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD202E",
    d: "M75.449 52.566c.007 0 .007-.007 0 0 .007-.007.007 0 0 0z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#BD202E",
    d: "M75.449 52.566c.007 0 .007-.007 0 0 .007-.007.007 0 0 0z",
    opacity: 0.35
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M75.449 52.566c.007 0 .007-.007 0 0 .007-.007.007 0 0 0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 80.277,
    x2: 107.078,
    y1: 10.871,
    y2: 3.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59723"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312,
    stopColor: "#F69822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 21.611,
    x2: 76.124,
    y1: 131.156,
    y2: 14.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 39.903,
    x2: 72.387,
    y1: 122.505,
    y2: 52.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#662E8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#CC2032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 23.576,
    x2: 78.089,
    y1: 124.078,
    y2: 7.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 29.138,
    x2: 57.786,
    y1: 116.292,
    y2: 54.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#282661"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#662E8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#9E2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949,
    stopColor: "#CC2032"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 35.68,
    x2: 90.192,
    y1: 129.722,
    y2: 12.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 31.692,
    x2: 86.205,
    y1: 136.692,
    y2: 19.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 39.272,
    x2: 93.784,
    y1: 131.397,
    y2: 14.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 38.865,
    x2: 93.378,
    y1: 131.208,
    y2: 14.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 69.406,
    x2: 81.455,
    y1: 65.493,
    y2: 39.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#9C2063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#C82037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#CC2135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87726"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApache);
export default __webpack_public_path__ + "static/media/Apache.18274500968ee1954dd920d229f6ce5f.svg";
export { ForwardRef as ReactComponent };